import * as ImpressionActionTypes from '../../constants/actiontypes/backoffice/impression';
import * as ImpressionLoadings from '../../constants/loadings/backoffice/impression';
import Letter from '../../constants/models/facilita/letter';
import * as R from 'ramda';


const ImpressionReducer = (state = {
    isLoading: [],
    userLetters: [],
    totalPages: 0,
    totalRecords: 0,
    currentPage: 0
}, action) => {
    switch(action.type){

        case ImpressionActionTypes.FETCH_USER_LETTERS_TO_PRINT_REQUEST:
            if (!state.isLoading.includes(ImpressionLoadings.FETCHING_USER_LETTERS)) {
                state.isLoading = state.isLoading.concat(ImpressionLoadings.FETCHING_USER_LETTERS);
            }
            return { ...state };

        case ImpressionActionTypes.FETCH_USER_LETTERS_TO_PRINT_SUCCESS:
            state.isLoading = state.isLoading.filter(l => l !== ImpressionLoadings.FETCHING_USER_LETTERS);
            state.userLetters = action.data.items.map(l => new Letter(l));
            return { ...state,
                isLoading: state.isLoading.filter(l => l !== ImpressionLoadings.FETCHING_USER_LETTERS),
                userLetters: action.data.items.map(l => new Letter(l)),
                totalPages: action.data.totalPages,
                totalRecords: action.data.totalRecords,
                currentPage: action.data.pageNumber + 1
            };


        case ImpressionActionTypes.FETCH_USER_LETTERS_TO_PRINT_FAILURE:
            state.isLoading = state.isLoading.filter(l => l !== ImpressionLoadings.FETCHING_USER_LETTERS);
            return { ...state };

        default:
            return state;
    }
}
export default ImpressionReducer;